import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      maxWidth: 140,
      height: 26,
      backgroundColor: COLORS.gray.gray90,
      borderRadius: theme.shape.borderRadiusSmall,
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'start',
      padding: theme.spacing(0, 1),
      color: COLORS.gray.gray30,
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(16),

      '& $buttonRemove': {
        visibility: 'hidden',
      },
      '&:hover': {
        boxShadow: theme.shape.boxShadowNormal,
        '& $buttonRemove': {
          visibility: 'visible',
        },
      },
    },
    icon: {
      fontSize: theme.typography.pxToRem(16),
      color: COLORS.gray.gray30,
    },
    label: {
      width: '100%',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      marginLeft: theme.spacing(1),
    },
    loader: {
      marginLeft: theme.spacing(1),
    },
    loadingTooltip: {
      maxWidth: 'none',
      padding: theme.spacing(1),
    },
    documentTooltip: {
      width: 190,
      maxHeight: 215,
    },
    buttonRemove: {
      backgroundColor: COLORS.gray.gray40,
      color: COLORS.neutral.white,
      borderRadius: '100%',
      border: '2px solid white',
      fontSize: theme.spacing(2),
      position: 'absolute',
      top: -8,
      right: -8,
      padding: theme.spacing(0.25),
      cursor: 'pointer',
    },
  }),
  { name: 'AttachmentOther' }
);
